import { API_AUTH } from "./common";

const DanhSachHopDongDeleteApi = {
  GetDanhSachHopDongDelete: ({
    NameCus,
    NameNQL,
    DiaChi,
    SDT,
    SoTienVay,
    KieuVayID,
    dateFrom,
    dateTo,
    NguoiXoa,
    pageIndex,
    pageSize,
  }) => {
    return API_AUTH.get(
      `thong-ke/danh-sach-hop-dong-bi-xoa?NameCus=${NameCus}&NameNQL=${NameNQL}&DiaChi=${DiaChi}&SDT=${SDT}&SoTienVay=${SoTienVay}&KieuVayID=${KieuVayID}&NguoiXoa=${NguoiXoa}&dateFrom=${dateFrom}&dateTo=${dateTo}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    );
  },
  xoaHopDongDelete: (Id) => {
    return API_AUTH.delete(`xoa-hop-dong-bi-xoa?Id=${Id}`, {});
  },
};

export default DanhSachHopDongDeleteApi;
